import { TaskDigest } from '@/components/TaskDigest';
import { useCalendarStore } from '@/stores/calendarStore';

export function TaskSidebar() {
  const { taskDigestCategories, initialExpandedCategories, setShowNetworkPanel, closeVideoPanel } = useCalendarStore();

  // Don't render if no tasks
  if (taskDigestCategories.length === 0) {
    return null;
  }

  return (
    <div className="h-screen w-80 flex-shrink-0 bg-[#0E0E0E] border-l border-white/[0.04] overflow-y-auto overflow-x-hidden">
      <div className="pt-6 min-h-full">
        <TaskDigest 
          categories={taskDigestCategories} 
          initialExpandedCategories={initialExpandedCategories}
          variant="inline"
          onShowNetworkPanel={() => setShowNetworkPanel(true)}
          onTaskClicked={closeVideoPanel}
        />
      </div>
    </div>
  );
}
